import React, { useState, useEffect } from 'react';
import LazyImage from '../LazyImage';


// function getConsistentIndex(files) {
//   if (files.length === 1) {
//     return 0;
//   }
//   // Get current minute (0-59)
//   const minute = new Date().getMinutes();

//   // Use minute parity (even/odd) to choose index 0 or 1
//   // This will flip every minute
//   return minute % 2;
// }

function getConsistentIndex(files) {
  if (files.length === 1) {
    return 0;
  }
  // Get current week number (1-53)
  const now = new Date();
  const oneJan = new Date(now.getFullYear(), 0, 1);
  const numberOfDays = Math.floor((now - oneJan) / (24 * 60 * 60 * 1000));
  const week = Math.ceil((numberOfDays + oneJan.getDay() + 1) / 7);

  // Use week parity (even/odd) to choose index 0 or 1
  // This will flip every week
  return week % 2;
}

const RandomImageGroup = ({ files, className = '', alt = '' }) => {
  const [randomIndexToShow, setRandomIndexToShow] = useState(-1);

  useEffect(() => {
    setRandomIndexToShow(getConsistentIndex(files.length));
  });
  return (
    <>
      {files.map((file, index) => {
        return (
          <>

            <LazyImage
              key={`lazy_${file.id}_${index}`}
              src={file.tiny.fullUrl}
              className={randomIndexToShow == index ? className : 'd-none'}
              alt={alt}
              srcset={`${file.medium.fullUrl} 1w`}
            />
          </>
        );
      })}
    </>
  );
};
export default RandomImageGroup;
